module.exports = __webpack_public_path__ + "media/application/images/tiktok-black-3f36f2c78e2dd82e5041f4f1dd520607.svg";